import React, {useEffect, useState} from 'react';
import {DashboardComponent} from '@KrashidBuilt/hotsauce-common/dist/components'
import './Dashboard.scss'
import {getPrice, getTotal} from '@KrashidBuilt/hotsauce-common/dist/utils/dashboardUtils'
import {
    getAggregateSales,
    getAllSales,
    getAllSalesPredefined,
    getAggregateSalesByUser,
    getAllUserSalesPredefined
} from '../api/reports';
import {Button, ButtonType, Colors} from '../components';
import {logout} from '../utilities';

const Dashboard = (props) => (
    <section className={'Dashboard'}>
        <Button
            type={ButtonType.Backward}
            colorTheme={Colors.Orange}
            label={'Return Home'}
            onClick={() => props.history.replace('/home')}
        />

        <Button
            type={ButtonType.Info}
            colorTheme={Colors.Sage}
            label={'View User Commission'}
            onClick={() => props.history.replace('/commission')}
        />

        <Button
            className={'LogoutButton'}
            label={'Logout'}
            onClick={logout}
            type={ButtonType.Logout}
        />

        <DashboardComponent
            columns={[
                {id: 'offering', numeric: true, label: 'Offering'},
                {id: 'quantity', numeric: true, label: 'Quantity'},
                {id: 'total', numeric: true, label: 'Total', align: 'right', format: (value) => getPrice(value)},
            ]}
            viewDataButton={true}
            pieChartTitle={'View Data by Sold Amount ($)'}
            pieChartTitleAlt={'View Data by Sold Quantity (#)'}
            TodayCallback={getAllSales}
            NonTodayCallback={getAllSalesPredefined}
            getAggregate={getAggregateSales}
            generateTotal={(sales) => getTotal(sales)}
            salesToChartData={
                (sales, amount) => (sales.map((s) => ({
                    y: amount ? parseInt(s.sales_item_total.replace('$', '').replaceAll(',', '')) : parseInt(s.sales_item_qty),
                    name: s.offering
                })))}
            salesToFormattedData={(sales => (
                    sales.map(s => ({
                        offering: s.offering,
                        quantity: s.sales_item_qty,
                        total: s.sales_item_total_num
                    })))
            )}
        />
    </section>
);

export default Dashboard;